import React from 'react'
import './styles.css'

export default () => {
  return (
    <div className="sidebar-welcome">
      <h2 className="sidebar-welcome-title">
        Welcome to TripPlanner
      </h2>
      <div className="sidebar-welcome-description">
        {/* Add a place to the map with the searchbox, and reorder places by dragging and dropping the names. */}
        Add a place to the map with the searchbox, and drag names to reorder.
        <br /><br />
        {/* You can indent and unindent places to build a hierarchy of places - e.g. make a list of countries to visit, then cities within those countries, then places within those cities. See the menu next to each place name for options. */}
        Create a hierarchy (e.g. countries / cities / attractions) by indenting items - see the menu next to each place name for options.
        <br /><br />
        {/* Create an account if you'd like to save your work - click Signup above. */}
        Save your trip by signing up for an account.
      </div>
    </div>
  )
}
